import React from 'react';
import { ReactComponent as NotFoundSvg } from '@/src/assets/icons/icon-not-found.svg';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';

interface ErrorPageProps {
  error?: Error;
  resetErrorBoundary?: () => void;
}
const ErrorPage = ({ error, resetErrorBoundary }: ErrorPageProps) => {
  return (
    <section className="flex h-screen flex-col items-center justify-center whitespace-pre-wrap text-center">
      <NotFoundSvg width={283} height={172} />
      <h1 className="text-[70px] font-bold">Error</h1>
      <div className="flex flex-col gap-1">
        <Typo color="gray2" typoType="h20sb">
          에러가 발생했습니다. 잠시 후 다시 시도해주세요.
        </Typo>
        <Typo color="gray2" typoType="b18r">
          Error : {error?.message ?? 'unknown error'}
        </Typo>
      </div>

      <div className="flex items-center gap-[8px] pt-[40px]">
        <Button
          style={{ width: '158px' }}
          onClick={() => window.history.back()}
        >
          Back to Previous
        </Button>
        {resetErrorBoundary && (
          <Button
            style={{ width: '158px' }}
            onClick={() => resetErrorBoundary?.()}
          >
            Retry
          </Button>
        )}
      </div>
    </section>
  );
};

export default ErrorPage;
